import React, {Component} from 'react';
import { Router as ReactRouter, Route, Redirect, browserHistory } from 'react-router';

import Auth from "../containers/Auth";

import FormPage from '../pages/FormPage';
import PageList from "../pages/PageList";
import PageRedirect from '../pages/PageRedirect';
import {IntlProvider} from "react-intl";
import translations from "../i18n";
import { connect } from "react-redux";

export const history = browserHistory;

if (!Intl.PluralRules) {
  import('intl-pluralrules/polyfill');
}

class Router extends Component {
  render = () => (
    <IntlProvider key={this.props.language}
                  locale={this.props.language}
                  defaultLocale="ru"
                  messages={translations[this.props.language] || translations.ru}>
      <Auth>
        <ReactRouter history={history}>
          <Route exact path='/residents/error/404' component={() => <p>ERROR 404: Route not found</p>}/>
          <Route exact path='/residents/redirect/:orn/:id' component={PageRedirect}/>
          <Route exact path='/residents/create/:orn/:slug' component={PageRedirect}/>
          <Route exact path='/residents/:id' component={FormPage}/>
          <Route exact path='/residents/' component={PageList}/>
          <Redirect from="*" to="/residents/error/404"/>
        </ReactRouter>
      </Auth>
    </IntlProvider>
  )
}

const mapStateToProps = state => ({
  language: state.common.language,
});

export default connect(mapStateToProps)(Router);
